import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Badge,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import Select from "react-select";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import SnackbarComponent from "../../../components/Snackbar/Snackbar";
import SiteFooterFourShape1 from "../../../assets/images/shapes/site-footer-four-shape-1.png";
import Logo2 from "../../../assets/images/resources/logo-2.png";
import AboutDetail3 from "../../../assets/images/resources/about-detail3.jpg";
import CTAThreeBgShape from "../../../assets/images/shapes/cta-three-bg-shape.png";
import { backendUrl } from "../../../constants/config";
import { Backdrop, Box, CircularProgress, Grid, Menu, Drawer, List, Divider, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import MenuDrawer from "../../../components/MenuDrawer/MenuDrawer";
import AppBar from "../../../components/AppBar/AppBar";
import TitleWithSearchBar from "../../../components/TitleWithSearchBar/TitleWithSearchBar";
import TitleWithoutSearchBar from "../../../components/TitleWithoutSearchBar/TitleWithoutSearchBar";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { GoogleLogin } from "@react-oauth/google";
import PricingOneShape2 from "../../../assets/images/shapes/pricing-one-shape-2.png";
import PricingOneShape3 from "../../../assets/images/shapes/pricing-one-shape-3.png";
import PricingOneShape4 from "../../../assets/images/shapes/pricing-one-shape-4.png";
import PricingOneShape1 from "../../../assets/images/shapes/pricing-one-shape-1.png";
import PricingOneIcon2 from "../../../assets/images/icon/pricing-one-icon-2.png";
import CTAThreeBgShape2 from "../../../assets/images/shapes/cta-three-bg-shape-2.png";
import jwtDecode from "jwt-decode";
import TalentSyncLogo from "../../../assets/images/talentSync_Logo.png";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import "./GettingStarted.css";


const GettingStarted = () => {
  
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  const DrawerList = (
    <Box
      sx={{ width: 250, backgroundColor: "#040b1e", color: "white" }}
      role="presentation"
      onClick={toggleDrawer(false)}
    >
      <div
        style={{
          display: "flex ",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          height: "fit-content",
        }}
      >
        <img src={TalentSyncLogo} style={{ width: "15%" }} alt="logo"></img>
        <span
          className="mobile-nav__close mobile-nav__toggler"
          style={{ marginTop: "5%" }}
        >
          <i className="fa fa-times" onClick={toggleDrawer(false)}></i>
        </span>
      </div>
      <List>
        {/* Navigation Items */}
        <ListItem button component="a" href="/">
          <ListItemText
            primary="Home"
            sx={{ textAlign: "left", color: "white" }}
          />
        </ListItem>
        <Divider />
        <ListItem button component="a" href="/about">
          <ListItemText
            primary="About"
            sx={{ textAlign: "left", color: "white" }}
          />
        </ListItem>
        <Divider />
        <ListItem button component="a" href="/pricing">
          <ListItemText
            primary="Pricing"
            sx={{ textAlign: "left", color: "white" }}
          />
        </ListItem>
        <Divider />
        <ListItem button component="a" href="/how-it-works">
          <ListItemText
            primary="How It Works"
            sx={{ textAlign: "left", color: "white" }}
          />
        </ListItem>
        <Divider />
        <ListItem button component="a" href="/contact">
          <ListItemText
            primary="Contact"
            sx={{ textAlign: "left", color: "white" }}
          />
        </ListItem>
        <Divider />
      </List>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "20px",
          marginTop: "8%",
        }}
      >
        <a href="#" className="fab fa-twitter" style={{ color: "white" }}></a>
        <a
          href="#"
          className="fab fa-facebook-square"
          style={{ color: "white" }}
        ></a>
        <a
          href="#"
          className="fab fa-pinterest-p"
          style={{ color: "white" }}
        ></a>
        <a href="#" className="fab fa-instagram" style={{ color: "white" }}></a>
      </div>
    </Box>
  );
  const navigate = useNavigate();
  const [err, setErr] = useState(null);
  const [user, setUser] = useState(null);
  const [success, setSuccess] = useState(null);

  const [paymentStatus, setPaymentStatus] = useState("");

  useEffect(() => {
    const talentSyncUser = JSON.parse(localStorage.getItem("TalentSyncUser"));
    if (talentSyncUser) {
      setUser(talentSyncUser);
    }
  }, []);

  const handleSubscription = async () => {
    try {
      const response = await axios.put(`${backendUrl}/user/updateUser`, {
        id: user?.id,
        user: {
          subscriptionBought: true,
        },
      });
      setSuccess("Processing your payment...");

      localStorage.setItem(
        "TalentSyncUser",
        JSON.stringify(response.data.updatedUser)
      );

      setTimeout(() => {
        setPaymentStatus("Payment successful! Thank you for your purchase.");
        navigate("/profile-form"); // Navigate after the timeout
      }, 2000);
    } catch (err) {
      console.log(err);
      setErr("Error Subscribing to plan.");
    }
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const [state, setState] = React.useState({
    left: false,
  });
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseError = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    seterror(false);
  };
  const [error, seterror] = useState(false);
  const [errorMsg, seterrorMsg] = useState("");

  return (
    <Box style={{ backgroundColor: "#f7f8fa", display: "flex", flex: 1 }}>
      <MenuDrawer admin toggleDrawer={toggleDrawer} state={state} />
      
      {/* <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop> */}
      <SnackbarComponent
        err={err}
        success={success}
        setErr={setErr}
        setSuccess={setSuccess}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          overflow: "hidden",
        }}
      >
        <AppBar title="Getting Started" toggleDrawer={toggleDrawer} />
        
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        ></Menu>

        <Grid container p={2}>
          <Grid item xs={12} md={12}>
            <Box
              mb={2}
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
              }}
            >
              {/* <TitleWithoutSearchBar title="Profile" halfWidth /> */}

              <section
                className=""
                style={{
                  position: "relative",
                  display: "block",
                  zIndex: "1",
                }}
              >
                <div
                  className="container"
                  style={{ paddingTop: "10px", paddingBottom: "10px" }}
                >

                  <div className="content-container">



                    {/* Getting Started Section */}
                    <h2>Getting Started: Let's Land Your Next Job!</h2>

                    <p>
                      Welcome! We're excited to help you accelerate your job search. Our service works by applying to relevant job openings directly on your behalf, using your own Gmail account to ensure seamless communication with potential employers.
                    </p>

                    <p>
                      To get started and ensure we represent you in the best possible way, please follow these two crucial steps:
                    </p>

                    <h3>1. Complete Your Profile:</h3>
                    <p>
                      Navigate to the <strong>"Profile"</strong> tab located in the <strong>left menu</strong>.
                    </p>
                    <p>
                      <strong>This is the most important step!</strong> Please fill out every section as thoroughly and accurately as possible. Think of this as building the foundation for all your job applications.
                    </p>
                    <p>
                      <strong>Why is this crucial?</strong> The information you provide here (your experience, skills, resume, preferences) is what we use to identify the right jobs and represent you effectively to recruiters and hiring managers. The more effort you put into your profile, the better we can tailor your applications.
                    </p>

                    <h3>2. Link Your Mailbox:</h3>
                    <p>
                      Go to the <strong>"Mailbox Link"</strong> option, also found in the <strong>left menu</strong>.
                    </p>
                    <p>
                      Follow the prompts to securely connect your personal Gmail account to our platform.
                    </p>
                    <p>
                      <strong>Important:</strong> During the authorization process, you will likely be asked to specify the duration of access. Please ensure you grant access for <strong>six months</strong>.
                    </p>
                    <p>
                      <strong>Why six months?</strong> This longer duration allows our service to continuously apply for jobs on your behalf without interruption and prevents you from needing to frequently re-link your account.
                    </p>
                    <p>
                      <strong>Why is linking needed at all?</strong> We send out applications <em>from</em> your email address. Linking your mailbox grants us the necessary permission to do this on your behalf. This also means that any replies from potential employers will come directly to your inbox!
                    </p>

                    <h3>What happens next?</h3>
                    <p>
                      Once your profile is complete and your mailbox is linked, we'll get to work identifying and applying for suitable job opportunities for you.
                    </p>

                    <hr style={{ margin: '2rem 0' }} /> {/* Optional separator */}

                    {/* Best Practices Section */}
                    <h2>Best Practices: Maximizing Your Success</h2>

                    <p>
                      To make the most of our service and increase your chances of landing interviews, keep these best practices in mind:
                    </p>

                    <ul>
                      <li>
                        <strong>Invest Time in Your Profile:</strong> Don't just fill the fields; elaborate! Use strong action verbs, quantify your achievements where possible, and double-check for any typos or grammatical errors. A polished profile makes a huge difference.
                      </li>
                      <li>
                        <strong>Keep Your Profile Updated:</strong> Job searching is dynamic. Did you gain a new skill? Complete a project? Update your resume? Make sure to reflect these changes in your profile on our platform promptly. An up-to-date profile ensures we're always presenting the latest version of you.
                      </li>
                      <li>
                        <strong>Ensure Your Mailbox Remains Connected:</strong> Occasionally, you might need to re-authenticate your mailbox link (e.g., if you change your Gmail password). Check periodically to ensure the connection is active so we can continue applying for you without interruption.
                      </li>
                      <li>
                        <strong>Check Your Linked Gmail Daily & Reply Promptly:</strong> Since applications are sent from your account, all responses from employers arrive directly in your Gmail inbox. <strong>Monitor it daily</strong> and <strong>reply promptly</strong> to any communications, especially interview requests or questions from HR. Timeliness is key in job searching!
                      </li>
                      <li>
                        <strong>Follow Up on Portal Application Requests:</strong> Sometimes, instead of proceeding directly, an HR representative might reply asking you to <em>formally apply through their company's career portal</em>. <strong>Please do this!</strong> Taking this extra step, even though we initiated the contact, significantly demonstrates your genuine interest in the role and the company to the employer.
                      </li>
                      <li>
                        <strong>Provide Specificity (If Possible):</strong> While filling out your profile, be as specific as possible about the types of roles, industries, and locations you're interested in. This helps us target the applications more effectively.
                      </li>
                    </ul>

                    <p>
                      By following these steps and practices, you empower us to be the most effective job application assistant for you. Let's work together to find your next great opportunity!
                    </p>

                  </div>



                </div>
              </section>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default GettingStarted;
